export default "__VITE_ASSET__DRi_x6Co__"